import { Shadow } from '@vfit/shared/atoms';
import { Logo } from '@vfit/shared-icons';

import { I_ConsumerShoppingCartAddress } from './consumerShoppingCartAddress.models';
import {
  AddressLogoWrapper,
  AddressRowBreak,
  AddressText,
  EditAddressLink,
  ShoppingCartAddressBar,
} from './consumerShoppingCartAddress.style';

const ConsumerShoppingCartAddress = ({
  address,
  editAddressLabel,
  onEditAddress,
  isLoading = false,
  isEditDisabled = false,
  embedded = false,
}: I_ConsumerShoppingCartAddress) => {
  if (!isLoading && !address) return null;

  return (
    <ShoppingCartAddressBar embedded={embedded}>
      {isLoading && !address ? (
        <Shadow height={20} width="100%" />
      ) : (
        address && (
          <>
            <AddressLogoWrapper>
              <Logo aria-hidden />
            </AddressLogoWrapper>
            <AddressText data-cs-mask="">{address}</AddressText>
            {editAddressLabel && onEditAddress && (
              <>
                <AddressRowBreak aria-hidden />
                <EditAddressLink
                  id="edit-address"
                  type="button"
                  onClick={onEditAddress}
                  disabled={isEditDisabled}
                >
                  {editAddressLabel}
                </EditAddressLink>
              </>
            )}
          </>
        )
      )}
    </ShoppingCartAddressBar>
  );
};

export default ConsumerShoppingCartAddress;
